"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ui_components_1 = require("@l2p/ui-components");
var useTableData_1 = require("./useTableData");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var Rules = function (_a) {
    var settings = _a.settings;
    var tableData = (0, useTableData_1.useTableData)(settings);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.tableContainer },
        react_1.default.createElement(ui_components_1.DataTable, { data: tableData, lazy: false })));
};
exports.default = Rules;
